import React, { useState } from "react";
import {
  Image,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from "react-native";
import RegionDropdown from "../app-header/religion-dropdown";
import { regionOptions } from "../app-header/region-options";
import get from "lodash/get";
import { FontFamily } from "../../styles/appStyles";

function openUrl(url) {
  if (url) {
    Linking.openURL(url);
  }
}

const SocialLinks = ({ footerData }) => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const { width } = useWindowDimensions();
  const isLg = width >= 1024;
  const socialLinks = get(footerData, "social_links") || [];
  const sections = get(footerData, "sections") || [];
  const lastSection = sections.slice(-1);
  const lastSectionLinks = [
    ...(lastSection[0]?.links || []),
    { name: "Help", url: "mailto:support@slowform.com" },
  ];
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const isMiddleEast = pathname?.includes("/middle-east");

  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <View style={styles.divider} />

        <View style={[styles.content, isLg && styles.contentLg]}>
          <View style={[styles.linkList, isLg && styles.linkListLg]}>
            {lastSectionLinks.map((item) => {
              const isSlowformLink = item.name.includes("Slowform");

              return (
                <TouchableOpacity
                  activeOpacity={0.8}
                  disabled={isSlowformLink}
                  key={item.name}
                  onMouseEnter={() => {
                    if (!isSlowformLink) {
                      setHoveredLink(item.name);
                    }
                  }}
                  onMouseLeave={() => setHoveredLink(null)}
                  onPress={() => openUrl(item.url)}
                >
                  <Text
                    style={[
                      styles.footerLink,
                      hoveredLink === item.name && styles.footerLinkHover,
                    ]}
                  >
                    {item.name}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>

          <View style={styles.actions}>
            <View>
              <RegionDropdown
                data={regionOptions}
                title={isMiddleEast ? "Middle East" : "India"}
                onDropdownOptionClick={(value) => {
                  if (typeof window !== "undefined") {
                    window.location.href =
                      value === "middle-east" ? "/middle-east" : "/";
                    return;
                  }

                  openUrl(value === "middle-east" ? "/middle-east" : "/");
                }}
              />
            </View>

            <View style={styles.socialList}>
              {socialLinks.map((item) => (
                <TouchableOpacity
                  activeOpacity={0.8}
                  key={item.title}
                  onPress={() => window.open(item.url, "_blank")}
                  style={styles.socialLink}
                >
                  <Image
                    resizeMode="contain"
                    source={{ uri: item.image }}
                    style={styles.socialIcon}
                  />
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "#f3eee2",
    paddingBottom: 150,
  },
  container: {
    alignSelf: "center",
    maxWidth: 1440,
    paddingHorizontal: 24,
    width: "100%",
  },
  divider: {
    borderTopColor: "#D8D0C1",
    borderTopWidth: 1,
  },
  content: {
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 16,
    justifyContent: "flex-start",
    paddingTop: 16,
  },
  contentLg: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  linkList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  linkListLg: {
    gap: 32,
  },
  footerLink: {
    color: "#8f897b",
    fontFamily: FontFamily.interRegular,
    fontSize: 12.8,
    lineHeight: 17.92,
  },
  footerLinkHover: {
    color: "#0f9e7a",
    textDecorationLine: "underline",
  },
  actions: {
    alignItems: "center",
    flexDirection: "row",
    gap: 24,
  },
  socialList: {
    alignItems: "center",
    flexDirection: "row",
    gap: 8,
  },
  socialLink: {
    alignItems: "center",
    borderColor: "#D8D0C1",
    borderRadius: 999,
    borderWidth: 1,
    height: 35,
    justifyContent: "center",
    width: 35,
  },
  socialIcon: {
    height: 20,
    width: 20,
  },
});

export default SocialLinks;
